export const palettes = {
  // Main Colors
  $primaryColor: "#123257",
  $secondaryColor: "#FF5F47",
  $backgroundColor: "#FFFFFF",
  $backgroundHover: "#FF9484",
  $textLightSubtle: "#F0F3F7",

  // Text Colors
  $primaryTextColor: "#333333",
  $secondaryTextColor: "#6D87AA",
  $placeholderTextColor: "#A1A1A1",

  // Status Colors
  $success: "#1CA568",
  $danger: "#F93B4C",
  $warning: "#FFC000",
  $info: "#078dee",
  $primaryLight: "#415B79",
  $oldAppBg: "#F2F5FB",
  $borderText: "#8A9FBB",
  $disabled: "#e2e2df",

  //Other Colors:
  $noticeSubtle: "#FFCDC6",
  $border: "#D3D3D3",
};

// static const Color primary = Color(0xffffffff);
// static const Color appBackGround = Color(0xfff2f5fb);
// static const Color textFieldStroke = Color(0xff6e6e6e);
// static const Color textBody = Color(0xff6d87aa);
// static const Color secondary = Color(0xffff5f47);
// static const Color accent = Color(0xff123257);
// static const Color success = Color(0xff1ca568);
// static const Color danger = Color(0xfff93b4c);
// static const Color warning = Color(0xffffc000);
// static const Color divider = Color.fromARGB(77, 51, 51, 51);
// static const Color printOutTextBody = Color(0xff333333);
// static const Color placeholder = Color(0xffa1a1a1);
// static const Color disabledFields = Color(0xffdcdcdc);
// static const Color text = Color(0xff000000);
// static const Color error = Color(0xfffa1c1c);
// static const Color fieldBorder = Color(0xfffa1c1c);
// static const Color fieldBackgroud = Color(0xff319df7);
// static const Color navIcons = Color(0xff4e698c);
// static const Color newAppBackGround = Color(0xFFFAFCFF);
// static const Color backgroundLightPrimary = Color(0xff0A77FF);
// static const Color transparent = Color(0x00000000);
// static const Color switchBackground = Color(0xffC3CEDD);
